import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { DeceasedForm } from './DeceasedForm';
import { DeceasedContainer, StyledPageTitle } from './styles';

export const Deceased: FC = (): JSX.Element => {
  const { id } = useParams<{ id: string }>();
  const isEditMode = !!id;

  return (
    <DeceasedContainer>
      <StyledPageTitle>
        <h1>{isEditMode ? 'Editace osobních infomací' : 'Nový zemřelý'}</h1>
      </StyledPageTitle>
      <DeceasedForm />
    </DeceasedContainer>
  );
};
